import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import { version } from '../../package.json'

Sentry.init({
  dsn: process.env.NODE_ENV === 'development' ? '' : 'https://a2b30a8c378440e386c0b959b73061a9@sentry.upho2015.com/7',
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      tracingOptions: {
        trackComponents: true
      }
    }),
    new Integrations.BrowserTracing()
  ],
  release: process.env.DOMAIN + '@' + version,
  tracesSampleRate: 1,
  logErrors: true
})
export { Sentry }
